import React from 'react';
import { Button, Dropdown, Space } from 'antd';
import { GlobalOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { updateUser } from '../../Profile/ProfileServices';
import { useErrorHandler } from '../../../Hooks/useErrorHandler';
import { LANGUAGE_OPTIONS, getLanguageName } from '../../../Constants/language';
import { getToken } from '../../../Config/ApiConfig';

const LanguageSwitcher = ({ inSidebar = false }) => {
  const { t, i18n } = useTranslation();
  const { handleError } = useErrorHandler();

  const changeLanguage = async (lng) => {
    if (lng === i18n.language) return;

    i18n.changeLanguage(lng);
    
    // Only attempt to save preference to backend if user is logged in
    if (getToken()) {
      try {
        await updateUser({ language: lng });
      } catch (error) {
        handleError(error);
      }
    }
  };

  const getCurrentLanguageName = () => {
    return getLanguageName(i18n.language);
  };

  const items = LANGUAGE_OPTIONS.map(({ value, label }) => ({
    key: value,
    label,
    onClick: () => changeLanguage(value),
  }));

  if (inSidebar) {
    return (
      <Dropdown
        menu={{ items, mode: 'vertical', inlineCollapsed: false }}
        placement="topRight"
        arrow
        trigger={['click']}
      >
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            height: '40px',
            cursor: 'pointer',
            color: 'inherit',
            width: '100%',
            gap: 8,
            overflow: 'visible',
          }}
        >
          <GlobalOutlined />
          <span style={{ whiteSpace: 'nowrap' }}>{getCurrentLanguageName()}</span>
        </div>
      </Dropdown>
    );
  }

  return (
    <Dropdown
      menu={{ items, mode: 'vertical', inlineCollapsed: false }}
      placement="bottomRight"
      arrow
      trigger={['click']}
    >
      <Button type="text" icon={<GlobalOutlined />}>
        <Space>
          {getCurrentLanguageName()}
        </Space>
      </Button>
    </Dropdown>
  );
};

export default LanguageSwitcher;
